var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueFilePond',_vm._b({ref:"pond",class:{'error__highlight': _vm.error },attrs:{"name":"file","files":_vm.initFileList,"server":_vm.imageUploadServer,"disabled":_vm.disabled || _vm.formAlreadySubmitted},on:{"updatefiles":_vm.updateFiles,"removefile":_vm.removeFile}},'VueFilePond',_vm.computedConfig,false))
}
var staticRenderFns = []

export { render, staticRenderFns }